module.exports = __webpack_public_path__ + "static/media/AP-CHAP04-CITATIONGERD.acf1888a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/StaticElement/img/AP-CHAP04-CITATIONGERD.png
// module id = 304
// module chunks = 0